<div>
  <div class="mt-1">
    <div class="d-flex align-items-center mb-2">
      <i class="fas fa-phone red mr-2"></i>
      <div class="mr-2">{{ 'single_phone_numbers' | i18next:{count: phoneNumbers.length} }}
      </div>
    </div>
    <div class="d-flex align-items-center flex-wrap ml-4">
      @for (phoneNumber of visibleNumbers; track phoneNumber) {
        <div
          class="phone-number-item mr-2">
          <div class="d-flex align-items-center p-1 bg-light rounded">
            <span class="small">{{ phoneNumber | phonenumber }}</span>
          </div>
        </div>
      }
      @if (showMoreNumbers) {
        @for (phoneNumber of additionalNumbers; track phoneNumber) {
          <div
            class="phone-number-item mr-2">
            <div class="d-flex align-items-center p-1 bg-light rounded">
              <span class="small">{{ phoneNumber | phonenumber }}</span>
            </div>
          </div>
        }
      }
      @if (hasMoreNumbers) {
        <button
          class="btn btn-sm btn-link d-flex align-items-center align-self-center"
          (click)="toggleShowMore()">
          <span class="small">{{ showMoreNumbers ? ('show_less' | i18next) : ('show_more' | i18next) }} ({{ additionalCount }})</span>
          <i
            class="fas ml-1"
            style="font-size: 0.7rem;"
            [ngClass]="{ 'fa-chevron-right': !showMoreNumbers, 'fa-chevron-left': showMoreNumbers }"
          ></i>
        </button>
      }
    </div>
  </div>
</div>
